window['assessment_relations#index'] = function () {
  $('#assessment_relations').on('select2-removed', function (e) {
    $.ajax({
      type: 'DELETE',
      url: 'assessment_relations/destroy_by_params/',
      data: { 'assessment_relation[assessment_task_id]': e.val },
      dataType: 'script',
      success: showSaveMessage($(e.target).parents('.block'))
    })
  })

  $('#assessment_relations').off('select2-selecting').on('select2-selecting', function (e) {
    $.ajax({
      type: 'POST',
      url: 'assessment_relations',
      data: { 'assessment_relation[assessment_task_id]': e.val },
      dataType: 'script',
      success: showSaveMessage($(e.target).parents('.block'))
    })
  })

  function showSaveMessage (tr) {
    $('.save-message', tr).fadeIn(function () {
      setTimeout(() => $('.save-message', tr).fadeOut(), 300)
    })
  }
}
